var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useState } from "react";
import styled from "styled-components";
import color from "detail/utils/color";
import { useDispatch } from "react-redux";
import FlexComponent from "detail/comments/flex";
import { dateFomat } from "../../utils/util";
import { customIp, customTextAreaAddBr, getInputTextMax } from "../review/libs/fn";
import { SET_REVIEW_COMMENT_DELETE, SET_REVIEW_COMMENT_UPDATE } from "../../reducers/review";
import { layerAction, validationAction } from "../../reducers/layer";
import Api2 from "../../utils/api2";
import ReviewLoading from "detail/components/main/reviewLoading";
import ButtonComponent from "../../comments/button";
var CommentItem = function (_a) {
    var data = _a.data, item_id = _a.item_id, review_id = _a.review_id, user_id = _a.user_id, commentCreateList = _a.commentCreateList, onClickHandler = _a.onClickHandler, dataLength = _a.dataLength;
    var dispatch = useDispatch();
    var areaRef = React.useRef(null);
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), updateFlag = _c[0], setUpdateFlag = _c[1];
    var _d = useState(''), textAreaValue = _d[0], setTextAreaValue = _d[1];
    var _e = useState(-1), updateAuthority = _e[0], setUpdateAuthority = _e[1];
    var layerClose = function () {
        dispatch(layerAction({
            name: null,
            data: null
        }));
    };
    /*todo 삭제*/
    var onClickDelete = function (comment_id) {
        var delAction = function () {
            setIsLoading(function (prev) { return !prev; });
            Api2.setCommentDelete(item_id, review_id, comment_id).then(function (res) {
                setIsLoading(function (prev) { return !prev; });
                if (res.data.result) {
                    layerClose();
                    dispatch({ type: SET_REVIEW_COMMENT_DELETE, payload: { review_id: review_id, comment_id: comment_id } });
                    if (dataLength === 1) {
                        onClickHandler(false);
                    }
                }
            }).catch(function (err) {
                var _a, _b;
                setIsLoading(function (prev) { return !prev; });
                var msg = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
                if (msg) {
                    dispatch(validationAction({ name: 'validation', data: { message: msg, btnTxt: '확인' } }));
                }
            });
        };
        Api2.getUserInfo().then(function (res) {
            var _a, _b;
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.id) {
                dispatch(layerAction({ name: 'delete', data: { message: '댓글을 삭제 하시겠습니까?', btnTxt: '삭제', action: delAction } }));
            }
            if (((_b = res.data) === null || _b === void 0 ? void 0 : _b.desc) === 'not_login') {
                dispatch(layerAction({ name: 'login' }));
            }
        });
    };
    /*todo 수정 팝업 오픈*/
    var onClickModify = function () {
        Api2.getUserInfo().then(function (res) {
            var _a, _b;
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.id) {
                setUpdateFlag(function (prev) { return !prev; });
                setTextAreaValue(data.message);
            }
            if (((_b = res.data) === null || _b === void 0 ? void 0 : _b.desc) === 'not_login') {
                dispatch(layerAction({ name: 'login' }));
            }
        });
    };
    var onClickCancelModify = function () {
        setUpdateFlag(function (prev) { return !prev; });
        setTextAreaValue('');
    };
    var onChangeHandler = function (e) {
        setTextAreaValue(getInputTextMax(e, 1000));
    };
    React.useEffect(function () {
        if (updateFlag) {
            if (areaRef.current) {
                /*textarea글 작성 줄 자동 늘림*/
                var target = areaRef.current;
                target.style.height = '0';
                target.style.height = "".concat(54 + target.scrollHeight, "px");
            }
        }
    }, [textAreaValue]);
    React.useEffect(function () {
        /*관리자 권한 매칭: 0이상, 매칭X: -1*/
        setUpdateAuthority(commentCreateList === null || commentCreateList === void 0 ? void 0 : commentCreateList.findIndex(function (v) { return ((v === null || v === void 0 ? void 0 : v.idxBManager) === (data === null || data === void 0 ? void 0 : data.idxBManager)); }));
    }, []);
    var onSubmitHandler = function () {
        setIsLoading(function (prev) { return !prev; });
        // 아이템id, 리뷰id, 댓글id
        var formData = { item_id: item_id, idx_thread: review_id, idx_comment: data.id, message: textAreaValue };
        Api2.setCommentUpdate(formData).then(function (res) {
            setIsLoading(function (prev) { return !prev; });
            data = res === null || res === void 0 ? void 0 : res.thread;
            if (res.data.desc === 'not_login') {
                dispatch(layerAction({ name: 'login' }));
                return false;
            }
            if (res.data.result) {
                dispatch({ type: SET_REVIEW_COMMENT_UPDATE, payload: { review_id: review_id, comment_data: res.data.thread } });
                setTextAreaValue('');
                setUpdateFlag(function (prev) { return !prev; });
            }
            else {
                var msg = '작성한 댓글이 보이지 않을 시 담당자에게 문의 바랍니다.';
                dispatch(validationAction({ name: 'validation', data: { message: msg, btnTxt: '확인' } }));
            }
        }).catch(function (err) {
            var _a, _b;
            setIsLoading(function (prev) { return !prev; });
            var msg = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message;
            if (msg) {
                dispatch(validationAction({ name: 'validation', data: { message: msg, btnTxt: '확인' } }));
            }
        });
    };
    var handleOpenReportProduct = function (comment_id) {
        Api2.getUserInfo().then(function (res) {
            var _a, _b;
            if ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.id) {
                dispatch(layerAction({ name: 'reportProductReview', data: { item_id: item_id, review_id: review_id, comment_id: comment_id } }));
            }
            if (((_b = res.data) === null || _b === void 0 ? void 0 : _b.desc) === 'not_login') {
                dispatch(layerAction({ name: 'login' }));
            }
        });
    };
    return (React.createElement(Wrap, null,
        isLoading && React.createElement(ReviewLoading, null),
        React.createElement(FlexComponent, { type: 'spaceBetween', className: 'comment-item-top' },
            React.createElement("div", null,
                React.createElement("span", { className: 'fw500 nameNick' }, data.idxBManager === 1 ? '행복쇼핑' : data.mallName),
                React.createElement("span", { className: 'text-bar' }),
                React.createElement("span", { className: 'f13 day' }, dateFomat(data.dateReg)),
                user_id === data.idxMember &&
                    React.createElement(React.Fragment, null,
                        updateAuthority > -1 && !updateFlag &&
                            React.createElement(React.Fragment, null,
                                React.createElement("span", { className: 'text-bar' }),
                                React.createElement("span", { className: 'f13 update hoverPointer', onClick: onClickModify }, "\uC218\uC815")),
                        updateFlag &&
                            React.createElement(React.Fragment, null,
                                React.createElement("span", { className: 'text-bar' }),
                                React.createElement("span", { className: 'f13 update hoverPointer', onClick: onClickCancelModify }, "\uC218\uC815\uCDE8\uC18C")),
                        updateAuthority > -1 && !updateFlag &&
                            React.createElement(React.Fragment, null,
                                React.createElement("span", { className: 'text-bar' }),
                                React.createElement("span", { className: 'f13 delete hoverPointer', onClick: function () { return onClickDelete(data.id); } }, "\uC0AD\uC81C")))),
            React.createElement("div", null,
                React.createElement("span", { className: 'f13 ip' }, customIp(data.ip)),
                user_id !== data.idxMember &&
                    React.createElement(React.Fragment, null,
                        React.createElement("span", { className: 'text-bar' }),
                        React.createElement("button", { className: 'f13 declaration hoverPointer', onClick: function () { return handleOpenReportProduct(data.id); }, disabled: data.hasMyNotify }, "\uC2E0\uACE0")))),
        React.createElement("div", { className: 'comment-item-middle' },
            !updateFlag && React.createElement("span", { className: 'fw500 message' }, customTextAreaAddBr(data.message)),
            updateFlag &&
                React.createElement("div", { className: 'comment-report' },
                    React.createElement("textarea", { value: textAreaValue, onChange: function (e) { return onChangeHandler(e); }, ref: areaRef }),
                    React.createElement(ButtonComponent, { type: 'default', className: 'comment-report-submit hoverPointer', onClick: onSubmitHandler }, "\uC218\uC815"),
                    React.createElement("span", { className: 'comment-max-count' },
                        textAreaValue.length,
                        "/1000")))));
};
export default React.memo(CommentItem);
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-weight: 500;\n    padding: 18px;\n    background: ", ";\n    color: ", ";\n    margin-bottom: 8px;\n    font-size: 14px;\n\n    &:last-child {\n        margin: 0;\n    }\n\n    .comment-item-top {\n        margin: 0 0 13px;\n\n        .fw500 {\n            font-weight: 500;\n        }\n\n        .f13 {\n            font-size: 12px;\n            color: ", ";\n        }\n\n        .declaration {\n            border: none;\n            background: transparent;\n            color: ", ";\n            &[disabled]{\n                color:", ";\n            }\n            &:not([disabled]):hover{\n                color:", ";\n            }\n        }\n\n        .update:hover,\n        .delete:hover{\n            color:", ";\n        }\n    }\n\n    .message{\n        word-break: break-all;\n        white-space:pre-wrap; // \uC5EC\uB7EC \uACF5\uBC31 \uC720\uC9C0\n    }\n\n    .ip {\n        color: ", ";\n    }\n\n    .comment-report{\n        margin:12px 0 0;\n        position:relative;\n        text-align:right;\n        textarea{\n            width:100%;\n            height:90px;\n            resize:none;\n            padding:16px 84px 0 20px;\n            overflow:hidden;\n        }\n        button{\n            position:absolute;\n            bottom:35px;\n            right:24px;\n            border: 1px solid ", ";\n            padding:2px 8px;\n            color:", ";\n        }\n        .comment-max-count{\n            margin:12px 0 0;\n            font-size:12px;\n            color:", ";\n        }\n    }\n    .comment-report-submit:hover {\n        background: ", ";\n    }\n}\n"], ["\n    width: 100%;\n    font-weight: 500;\n    padding: 18px;\n    background: ", ";\n    color: ", ";\n    margin-bottom: 8px;\n    font-size: 14px;\n\n    &:last-child {\n        margin: 0;\n    }\n\n    .comment-item-top {\n        margin: 0 0 13px;\n\n        .fw500 {\n            font-weight: 500;\n        }\n\n        .f13 {\n            font-size: 12px;\n            color: ", ";\n        }\n\n        .declaration {\n            border: none;\n            background: transparent;\n            color: ", ";\n            &[disabled]{\n                color:", ";\n            }\n            &:not([disabled]):hover{\n                color:", ";\n            }\n        }\n\n        .update:hover,\n        .delete:hover{\n            color:", ";\n        }\n    }\n\n    .message{\n        word-break: break-all;\n        white-space:pre-wrap; // \uC5EC\uB7EC \uACF5\uBC31 \uC720\uC9C0\n    }\n\n    .ip {\n        color: ", ";\n    }\n\n    .comment-report{\n        margin:12px 0 0;\n        position:relative;\n        text-align:right;\n        textarea{\n            width:100%;\n            height:90px;\n            resize:none;\n            padding:16px 84px 0 20px;\n            overflow:hidden;\n        }\n        button{\n            position:absolute;\n            bottom:35px;\n            right:24px;\n            border: 1px solid ", ";\n            padding:2px 8px;\n            color:", ";\n        }\n        .comment-max-count{\n            margin:12px 0 0;\n            font-size:12px;\n            color:", ";\n        }\n    }\n    .comment-report-submit:hover {\n        background: ", ";\n    }\n}\n"])), color.colorF9, color.color333, color.color666, color.color418, color.color999, color.color999, color.color418, color.color999, color.colorCCC, color.color666, color.color999, color.colorF6);
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/commentItem.tsx
// module id = 248
// module chunks = 0